import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Footer from 'cccisd-footer';
import NavBar from '../../components/NavBar';
import { setInsecure } from '../../reducers/security.js';
import style from './style.css';

const Boilerplate = window.cccisd.boilerplate;
const Fortress = window.cccisd.fortress;

class FluidLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        isFixed: PropTypes.bool,
        isInsecure: PropTypes.bool,
        className: PropTypes.string,
        showFooter: PropTypes.bool,
        noLogoLink: PropTypes.bool,

        // From redux
        isSecure: PropTypes.bool.isRequired,
        lastLogin: PropTypes.string.isRequired,
        setInsecure: PropTypes.func.isRequired,
    };

    static defaultProps = {
        className: 'container',
        showFooter: true,
        noLogoLink: false,
    };

    componentDidMount() {
        const { isInsecure, lastLogin, isSecure } = this.props;
        if (Fortress.user.actual.role.handle === 'guest') {
            return;
        }
        if (!isInsecure && lastLogin === Fortress.user.actual.user.last_login && !isSecure) {
            window.location = Boilerplate.url('/api/user/logout');
        }
        if (isInsecure) {
            this.props.setInsecure();
        }
    }

    render() {
        const { className, showFooter, children, noLogoLink } = this.props;

        return (
            <div
                className={`${style.wrapper} ${
                    Fortress.user.acting.role.handle === 'learner' ? style.disableGestures : ''
                }`}
            >
                <div className={style.header}>
                    <NavBar className={className} noLogoLink={noLogoLink} />
                </div>

                <div className={style.body}>
                    <div className={className}>{children}</div>
                </div>

                {showFooter && <Footer className={className} />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isSecure: state.app.security.isSecure,
    lastLogin: state.app.security.lastLogin,
});

export default connect(mapStateToProps, { setInsecure })(FluidLayout);
